import {
  FilterMode,
  UserNotification_OrderBy,
  UserNotification,
  SortOrder,
  UserNotification_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const userNotificationService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.userNotificationOne({ id });
    return result.userNotificationOne as UserNotification;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: UserNotification_OrderBy[] | null = null,
    filter: UserNotification_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: UserNotification_Filter | undefined;
    if (searchValue !== "") {
      where = {
        OR: [
          { title: { contains: searchValue, mode: FilterMode.Insensitive } },
          { body: { contains: searchValue, mode: FilterMode.Insensitive } },
        ],
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.userNotificationListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [{ title: SortOrder.Asc }, { body: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.userNotificationListWithOffset
    ) as UserNotification[];
    return { list, orderBy };
  },
};
